import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';

type MuiMenuItem = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiMenuItem'];
  defaultProps?: ComponentsProps['MuiMenuItem'];
  variants?: ComponentsVariants['MuiMenuItem'];
};

export const MuiMenuItem: MuiMenuItem = {
  styleOverrides: {
    root: {
      fontSize: 14,
      '& .MuiListItemText-root': {
        paddingLeft: 8,
      },
    },
  },
};
